import React from "react";
import PropTypes from "prop-types";
import {SVPLoadingSubmitButton} from "Components/Buttons/SVPLoadingSubmitButton";

export const AuditMediaButton = ({auditID, isLoading = false, isPublic = false}) => {
    return (
        <SVPLoadingSubmitButton
            colClassName={"float-end mb-3 z-2"}
            buttonText={"Media"}
            isLoading={isLoading}
            onClick={() => window.location.href = isPublic ?
                `/public-audits/${auditID}/media` :
                `/audits/${auditID}/media`}
        />
    );
};

AuditMediaButton.propTypes = {
    auditID: PropTypes.number.isRequired,
    isLoading: PropTypes.bool,
    isPublic: PropTypes.bool,
};
